/**
 * ProHabbo
 *
 * Henrique Arthur <eu@henriquearthur.com.br>
 */

Summer = {
    init: function() {
        $(".summer-habbo-featured").hover(
            function() {
                $(this).click();
            },
            function() {
            }
        );
    }
}
